<div class="font-bold mb-3" i18n>
  When your customer is in a visiting network, the user's device will periodically attempt to obtain your home network. The home network
  search is based on the PLMNs and their priorities you have specified in Equivalent PLMN list, Home PLMN list, and roaming list. In this
  section, you can indicate how frequently user's device should search for the home network. First, please answer the following question.
</div>
<div class="font-bold mb-3" i18n>Does your User Equipment support NB-IOT, GERAN EC-GSM-IoT, or Category M1 of E-UTRAN enhanced-MTC</div>
<div class="ml-6 mb-3">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="updateUserEqipmentOption()"
          name="higherPriorityPLMN.supported"
          inputId="higherPriorityPLMN.supported#1"
          value="1"
          [(ngModel)]="profileValues.higherPriorityPLMN.supported"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="higherPriorityPLMN.supported#1" i18n>Yes</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="updateUserEqipmentOption()"
          name="higherPriorityPLMN.supported"
          inputId="higherPriorityPLMN.supported#0"
          value="0"
          [(ngModel)]="profileValues.higherPriorityPLMN.supported"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="higherPriorityPLMN.supported#0" i18n>No</label>
      </td>
    </tr>
  </table>
</div>
<div class="ml-6 mr-6">
  <table>
    <tr>
      <td>
        <div class="font-bold mr-3" i18n>Search Period:</div>
      </td>
      <td>
        <p-select
          *ngIf="+profileValues.higherPriorityPLMN.supported === 1"
          [options]="searchPeriodOptionsSupported"
          [(ngModel)]="profileValues.higherPriorityPLMN.searchPeriod"
          dataKey="value"
          optionLabel="label"
          i18n-placeholder
          placeholder="Please Select:"
          appendTo="body"
          (onChange)="handleFormEvents()"
        ></p-select>
        <p-select
          *ngIf="+profileValues.higherPriorityPLMN.supported === 0"
          [options]="searchPeriodOptionsNotSupported"
          [(ngModel)]="profileValues.higherPriorityPLMN.searchPeriod"
          dataKey="value"
          optionLabel="label"
          i18n-placeholder
          placeholder="Please Select:"
          appendTo="body"
          (onChange)="handleFormEvents()"
        ></p-select>
      </td>
      <td>
        <div *ngIf="+profileValues.higherPriorityPLMN.supported === 1" class="ml-3" i18n>(default: 72 hours)</div>
        <div *ngIf="+profileValues.higherPriorityPLMN.supported === 0" class="ml-3" i18n>(default: 60 minutes)</div>
      </td>
    </tr>
  </table>
</div>
